gsap.registerPlugin(ScrollTrigger);

let smoother;
let mm = gsap.matchMedia();
let headerOffset;
let lastScrollTop = 0;

// Desktop ScrollSmoother
mm.add('(min-width: 1024px)', () => {
    smoother = ScrollSmoother.create({
        smooth: 0.7,
        effects: true,
        smoothTouch: false,
        wrapper: '#smooth-wrapper',
        normalizeScroll: true, // Important for Safari
    });
    headerOffset = '-101%';
});

// Mobile ScrollSmoother - lighter configuration
mm.add('(max-width: 1023px)', () => {
    smoother = ScrollSmoother.create({
        smooth: 0.7,
        effects: true,
        smoothTouch: false, // Keep native touch scrolling
    });
    headerOffset = '-115%';
});

// Event delegation for anchor links with hash
document.addEventListener('click', function (event) {
    // Check if clicked element is an anchor with href containing "#"
    const target = event.target.closest('a[href*="#"]');
    if (!target) return;

    const href = target.getAttribute('href');
    const hashIndex = href.indexOf('#');

    if (hashIndex !== -1) {
        const targetHash = href.slice(hashIndex);
        const baseUrl = href.slice(0, hashIndex);

        // Get the current URL without the hash
        const currentUrlWithoutHash = window.location.href.split('#')[0];

        // Normalize baseUrl and currentUrlWithoutHash for comparison
        const link = document.createElement('a');
        link.href = baseUrl;

        if (link.href === currentUrlWithoutHash || baseUrl === '') {
            handleTargetHash(targetHash, event);
        }
    }
});

function handleTargetHash(targetHash, event) {
    if (targetHash !== '#wc-block-components-totals-coupon__form') {
        event.preventDefault();
        const targetElement = document.querySelector(targetHash);

        if (targetElement && typeof smoother !== 'undefined') {
            // Use GSAP ScrollSmoother instead of jQuery animate
            gsap.to(smoother, {
                scrollTop: smoother.offset(targetElement, '-100px'), // Your offset here
                duration: 0.8, // Smooth duration instead of 0
                ease: 'power2.out',
            });
        }
    }
}

// Scroll To function when page is loaded with hash in URL
const urlHash = window.location.href.split('#')[1];
if (urlHash) {
    const scrollElem = document.querySelector('#' + urlHash);
    if (scrollElem && typeof smoother !== 'undefined') {
        gsap.to(smoother, {
            scrollTop: smoother.offset(scrollElem, '-200px'),
            duration: 1,
            delay: 0.5,
        });
    }
}

// notify button prevent add to cart logic but open modal
const notifyButtons = document.querySelectorAll('.notify-button');
const notifyModal = document.querySelector('.notify-modal');
const notifyCloseButtons = document.querySelectorAll('.notify-close-button, .notify-close-button__icon');
const modalContent = document.querySelector('.modal-content');

// Function to show modal with fade-in effect
function showModal() {
    if (notifyModal) {
        notifyModal.style.display = 'block';
        // Force reflow to ensure display change takes effect
        notifyModal.offsetHeight;
        notifyModal.classList.add('show');
    }
}

// Function to hide modal with fade-out effect
function hideModal() {
    if (notifyModal) {
        notifyModal.classList.remove('show');
        // Wait for fade-out transition to complete before hiding
        setTimeout(() => {
            notifyModal.style.display = 'none';
        }, 300);
    }
}

// Add click event to all notify buttons to show modal
notifyButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        event.preventDefault();
        showModal();
    });
});

// Add click event to close buttons
notifyCloseButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        event.preventDefault();
        hideModal();
    });
});

// Add click event to modal background (but not modal content)
if (notifyModal) {
    notifyModal.addEventListener('click', (event) => {
        // Only close if clicking on the modal background, not the content
        if (event.target === notifyModal) {
            hideModal();
        }
    });
}

// Prevent modal from closing when clicking inside modal content
if (modalContent) {
    modalContent.addEventListener('click', (event) => {
        event.stopPropagation();
    });
}

// Alternative: Single function that handles both URL and anchor
function smartNavigate(fullUrl) {
    const [baseUrl, anchor] = fullUrl.split('#');

    if (!anchor) {
        // No anchor, just navigate normally
        window.location.href = fullUrl;
        return;
    }

    const currentPath = window.location.pathname;
    const url = new URL(baseUrl, window.location.origin);
    const targetPath = url.pathname;

    if (currentPath === targetPath) {
        // Same page, just scroll to anchor
        scrollToAnchor(anchor);
    } else {
        // Different page, navigate with anchor
        window.location.href = fullUrl;
    }
}

// Vanilla JS fade in function
function fadeIn(element, duration) {
    element.style.opacity = 0;
    element.style.display = 'block';

    const start = performance.now();

    function fade(timestamp) {
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / duration, 1);

        element.style.opacity = progress;

        if (progress < 1) {
            requestAnimationFrame(fade);
        }
    }

    requestAnimationFrame(fade);
}

// Vanilla JS fade out function
function fadeOut(element, duration, callback) {
    const start = performance.now();
    const startOpacity = parseFloat(window.getComputedStyle(element).opacity) || 1;

    function fade(timestamp) {
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / duration, 1);

        element.style.opacity = startOpacity * (1 - progress);

        if (progress < 1) {
            requestAnimationFrame(fade);
        } else {
            element.style.display = 'none';
            if (callback) callback();
        }
    }

    requestAnimationFrame(fade);
}

// Age-gate validation logic
function initAgeGate() {
    const ageGate = document.querySelector('[data-age-gate]');
    const yesButton = document.querySelector('[data-age-gate-yes]');
    const noButton = document.querySelector('[data-age-gate-no]');
    const messageElement = document.querySelector('.age-gate-message');

    if (!ageGate || !yesButton || !noButton) return;

    // Check if already validated via cookie
    if (Cookies.get('ageGateValidated') === 'true') {
        ageGate.style.display = 'none';
        document.body.classList.remove('age-gate-active');
        // lenis.start();
        smoother.paused(false);
        return;
    }

    // Show age-gate if not validated - vanilla JS fade in
    fadeIn(ageGate, 500);
    document.body.classList.add('age-gate-active');
    smoother.paused(true);

    // Handle "I am 21+" button click
    yesButton.addEventListener('click', function (e) {
        e.preventDefault();

        // Store in cookie first to remember the validation (30 days)
        Cookies.set('ageGateValidated', 'true', { expires: 30 });

        // User confirms they are 21+ - fade out age gate
        fadeOut(ageGate, 500, function () {
            // Remove age-gate class from body and start Lenis
            document.body.classList.remove('age-gate-active');
            smoother.paused(false);
        });
    });

    // Handle "I am not 21+" button click
    noButton.addEventListener('click', function (e) {
        e.preventDefault();

        // User confirms they are under 21
        showMessage('You must be 21 or older to enter this site.', 'error');
    });

    function showMessage(message, type) {
        if (messageElement) {
            messageElement.textContent = message;
            messageElement.style.display = 'block';
            messageElement.className = `age-gate-message ${type}`;
            // Hide message after 3 seconds
            setTimeout(() => {
                messageElement.style.display = 'none';
            }, 3000);
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
});
